var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepeatSmartApp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 675,
    height: 999,
    viewBox: "0 0 675 999",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.714 733L183.15 551.848H139.194V733H45.954V268.132H220.446C256.41 268.132 287.046 274.57 312.354 287.446C337.662 299.878 356.532 316.972 368.964 338.728C381.84 360.04 388.278 384.016 388.278 410.656C388.278 441.292 379.398 469.042 361.638 493.906C343.878 518.326 317.46 535.198 282.384 544.522L393.606 733H285.714ZM139.194 481.918H217.116C242.424 481.918 261.294 475.924 273.726 463.936C286.158 451.504 292.374 434.41 292.374 412.654C292.374 391.342 286.158 374.914 273.726 363.37C261.294 351.382 242.424 345.388 217.116 345.388H139.194V481.918Z",
    fill: "#7BC044"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M575.372 0L435.177 248.776L427 3.50375L575.372 0ZM450.366 198.554L556.68 11.6796L436.345 14.0154L450.366 198.554Z",
    fill: "#65C296"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.694 11.6816L450.38 198.556L436.359 14.0174L556.694 11.6816ZM452.716 174.029L539.17 22.1932L446.874 23.3613L452.716 174.029Z",
    fill: "#65C296"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M674.674 223.083L458.542 325.864L602.241 116.799L674.674 223.083ZM499.432 289.657L657.15 220.748L598.736 138.99L499.432 289.657Z",
    fill: "#EECA3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M657.139 221.916L500.589 290.826L598.725 141.326L657.139 221.916ZM519.281 273.306L643.12 214.908L602.23 154.174L519.281 273.306Z",
    fill: "#EECA3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M661.828 360.897L627.948 464.846L478.407 363.233L661.828 360.897ZM616.265 430.975L632.621 381.921H545L616.265 430.975ZM625.612 436.815L643.136 369.073L528.644 376.081L643.136 369.073L625.612 436.815Z",
    fill: "#EB744A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatSmartApp);
export default __webpack_public_path__ + "static/media/RepeatSmartApp.a2d0b9901ffeb146cb13be5252deb168.svg";
export { ForwardRef as ReactComponent };